import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";

function Root() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return (
    <React.StrictMode>
      <App />
      {mounted && <Toaster position="top-center" richColors />}
    </React.StrictMode>
  );
}

const container = document.getElementById("root");
const tree = <Root />;

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
